import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from '../Logs.module.css';
import TagButton from './TagButton';
import { tagLabel } from '../../../utils/i18nLabels';

// `value` is the FILTER VALUE — Filters.js sends `selectedTags.join(',')
// .toLowerCase()` to the API, and selection is tracked by it. Only the
// displayed text is translated; translating the value in place would have sent
// "Création" to the backend and silently returned no rows.
const Tags = ({ selectedTags, setSelectedTags, setPageNumber }) => {
  const { t } = useTranslation();
  const tags = [
    { id: 1, value: 'Login' },
    { id: 2, value: 'Folder' },
    { id: 3, value: 'File' },
    { id: 4, value: 'User' },
    { id: 5, value: 'Client' },
    { id: 6, value: 'Create' },
    { id: 7, value: 'Edit' },
    { id: 8, value: 'Delete' },
    { id: 9, value: 'Copy' },
    { id: 10, value: 'Move' },
    { id: 11, value: 'Share' },
    { id: 12, value: 'Download' },
    { id: 13, value: 'Password' },
  ].map(tag => ({ ...tag, label: tagLabel(t, tag.value) }));

  const handleAddTag = item => {
    if (!selectedTags.includes(item)) {
      setSelectedTags(prevVal => [...prevVal, item]);
    } else {
      setSelectedTags(prevVal => prevVal.filter(d => d !== item));
    }
    setPageNumber(1);
  };

  return (
    <div className={classes.filter_tags_box}>
      <p className={classes.filter_text_box_label}>{t('screens.logs.tagsLabel')}</p>
      <div className='flex' style={{ flexWrap: 'wrap' }}>
        {/* Sort on the DISPLAYED text, so the chips read alphabetically in the
            reader's language rather than in English order. */}
        {tags
          .slice()
          .sort((a, b) => a.label.localeCompare(b.label))
          .map(tag => (
            <TagButton key={tag.id} label={tag.label} active={selectedTags.includes(tag.value)} onClick={() => handleAddTag(tag.value)} />
          ))}
      </div>
    </div>
  );
};

export default Tags;
